<template>
<otif-modal :value="value" 
        @input="$emit('input', $event)" 
        v-bind:title="dlgtitle"
        class="text-left"
        v-bind:noclosebtn="true">
    <p>
        {{ecmResourceStrings.txtPasswordDescription}}
    </p>
    <otif-passwordInput
        ref="firstInput"
        v-model="$v.password.$model"
        v-bind:label="ecmResourceStrings.lblDBpassword"
        :validation="$v.password"
        v-bind:invalidMessage="ecmResourceStrings.errPasswordMatch"
       />
    <otif-passwordInput
        v-model="$v.password2.$model"
        v-bind:label="ecmResourceStrings.lblConfirmPassword"
        :validation="$v.password2"
        v-bind:invalidMessage="ecmResourceStrings.errPasswordMatch"/>
    <template slot="footer">
        <otif-button className="primary" @click.native="save" :disabled="$v.$invalid">{{ecmResourceStrings.lblSave}}</otif-button>
        <otif-button className="secondary" @click.native="$emit('input', false)">{{ecmResourceStrings.lblCancel}}</otif-button>
    </template>
</otif-modal>
</template>

<script>

import axios from 'axios';
import { validationMixin } from 'vuelidate';
import { required, sameAs } from 'vuelidate/lib/validators';

export default {
    props: ['value'],
    mixins: [ validationMixin ],
    data() {
        return {
            dlgtitle:'',
            password: '',
            password2: '',
            ecmResourceStrings: require('../../utils/resourceECM.js'),
        }
    },

    validations: {
        password: {
            required
        },
        password2: {
            required,
            sameAsPassword: sameAs('password')
        }
    },

    methods: {
        save()
        {
            this.$emit('input', false);
            const datapsw = this.password;
            this.password = '';
            this.password2 = '';
            this.$v.$reset();
            this.$parent.saveConfirmed(datapsw);
        }
    }
}
</script>
